import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import {
  ApiListResponse,
  PagedApiResponse,
  Pagination,
} from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { AxiosResponse } from 'axios';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { OrgRoleDto, OrgRoleForUserDto, QueryParams } from '../../types';
import { OrgRoleKeys } from './orgrole.keys';

// eslint-disable-next-line @typescript-eslint/no-shadow
export async function getOrgRoleList(queryString: string) {
  // eslint-disable-next-line no-param-reassign, eqeqeq
  queryString = queryString == '' ? queryString : `?${queryString}`;

  return clients.admin
    .get(`/orgroles${queryString}`)
    .then((response: AxiosResponse<ApiListResponse<OrgRoleDto>>) => {
      const { data } = response.data as ApiListResponse<OrgRoleDto>;

      return {
        data,
        pagination: JSON.parse(response.headers['x-pagination']) as Pagination,
      } as PagedApiResponse<OrgRoleDto>;
    });
}

export function useGetOrgRoleList({ pageNumber, pageSize, filters, sortOrder }: QueryParams) {
  const queryParams = queryString.stringify({
    pageNumber,
    pageSize,
    filters,
    sortOrder,
  });

  return useQuery(OrgRoleKeys.list(queryParams), () => getOrgRoleList(queryParams));
}

export async function getOrgRoleListByUser(userId: string) {
  return clients.admin
    .get(`/orgroles/byuser/${userId}`)
    .then((response: AxiosResponse<OrgRoleForUserDto[]>) => response.data as OrgRoleForUserDto[]);
}

export function useGetOrgRoleListByUser(userId: string) {
  return useQuery(OrgRoleKeys.byUsers(), () => getOrgRoleListByUser(userId), {
    enabled: userId !== null && userId.length > 0,
  });
}
